const SkillsList = {
  frontend: [
    {
      name: "Javascript",
      color: "#d9c400",
      link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
      img: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/480px-Unofficial_JavaScript_logo_2.svg.png",
    },
    {
      name: "Typescript",
      color: "#2d79c7",
      link: "https://www.typescriptlang.org/",
      img: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Typescript_logo_2020.svg/1024px-Typescript_logo_2020.svg.png",
    },
    {
      name: "React",
      color: "#53d2fa",
      link: "https://reactjs.org/",
      img: "https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png",
    },
    {
      name: "Next.js",
      color: "#444",
      link: "https://nextjs.org/",
      img: "https://cdn.cdnlogo.com/logos/n/80/next-js.svg",
    },
    {
      name: "Redux",
      color: "#764abc",
      link: "https://redux.js.org/",
      img: "https://raw.githubusercontent.com/reactjs/redux/24bab8f05987542ffd186c19400a80f12f717492/logo/logo.png",
    },
    {
      name: "React-Query",
      color: "#ff4154",
      link: "https://tanstack.com/query/latest",
      img: "https://assets.streamlinehq.com/image/private/w_300,h_300,ar_1/f_auto/v1/icons/2/react-query-icon-xjukes5xosrrwg3y3ics1f.png/react-query-icon-2dw36yx2b016w37mbipyn.png?_a=DATAg1AAZAA0",
    },
    {
      name: "Formik",
      color: "#0152cc",
      link: "https://formik.org/",
      img: "https://images.opencollective.com/formik/7ba0331/logo/256.png",
    },
    {
      name: "I18next",
      color: "#009788",
      link: "https://i18next.com/",
      img: "https://images.icon-icons.com/2699/PNG/512/inext_logo_icon_170002.png",
    },
    {
      name: "Styled Comp",
      color: "#b65f94",
      link: "https://styled-components.com/",
      img: "https://miro.medium.com/max/318/1*p1TndLk3UsGPBsM7qHPZIw.png",
    },
    {
      name: "Material-UI",
      color: "#007fff",
      link: "https://www.w3schools.com/css/",
      img: "https://cdn.worldvectorlogo.com/logos/material-ui-1.svg",
    },
    {
      name: "CSS3",
      color: "#33a9dc",
      link: "https://www.w3schools.com/css/",
      img: "https://cdn.cdnlogo.com/logos/c/18/css.svg",
    },
    {
      name: "HTML5",
      color: "#f37844",
      link: "https://www.w3.org/html/",
      img: "https://cdn.worldvectorlogo.com/logos/html-1.svg",
    },
  ],
  backend: [
    {
      name: "Node.js",
      color: "#4e9a42",
      link: "https://nodejs.org/en/",
      img: "https://cdn-icons-png.flaticon.com/512/5968/5968322.png",
    },
    {
      name: "Express",
      color: "#494949",
      link: "https://expressjs.com",
      img: "https://www.guayerd.com/wp-content/uploads//2021/04/expressjs-logo.svg",
    },
    {
      name: "MongoDB",
      color: "#68a95d",
      link: "https://www.mongodb.com/",
      img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
    },
    {
      name: "SQL",
      color: "#3399db",
      link: "https://www.w3schools.com/sql/",
      img: "https://www.freeiconspng.com/uploads/sql-server-icon-png-29.png",
    },
    {
      name: "Kafka",
      color: "#444",
      link: "https://kafka.apache.org/",
      img: "https://svn.apache.org/repos/asf/kafka/site/logos/originals/png/ICON%20-%20Black%20on%20Transparent.png",
    },
    {
      name: "Redis",
      color: "#d82c20",
      link: "https://redis.io/",
      img: "https://images.icon-icons.com/2415/PNG/512/redis_plain_logo_icon_146366.png",
    },
    {
      name: "Swagger",
      color: "#133b47",
      link: "https://swagger.io/",
      img: "https://cdn.jsdelivr.net/gh/homarr-labs/dashboard-icons/png/swagger.png",
    },
    {
      name: "Socket.IO",
      color: "#444",
      link: "https://socket.io/",
      img: "https://upload.wikimedia.org/wikipedia/commons/9/96/Socket-io.svg",
    },
    {
      name: "JWT",
      color: "#546e7a",
      link: "https://jwt.io/",
      img: "https://img.icons8.com/color/480/java-web-token.png",
    },
    {
      name: "OAuth2.0",
      color: "#3d3d3d",
      link: "https://oauth.net/",
      img: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Oauth_logo.svg/598px-Oauth_logo.svg.png",
    },
  ],
  crm: [
    {
      name: "SalesForce",
      color: "#00a2e1",
      link: "https://www.salesforce.com/",
      img: "https://images.icon-icons.com/2699/PNG/512/salesforce_logo_icon_170764.png",
    },
    {
      name: "Monday",
      color: "#fb275d",
      link: "https://monday.com/",
      img: "https://monday.com/p/wp-content/uploads/2020/07/Icon10-1.png",
    },
    {
      name: "Make",
      color: "#5800c0",
      link: "https://www.make.com/en",
      img: "https://play-lh.googleusercontent.com/48jrCqrPKi0Af5z9gMVGVVap1EEfswtQuwh9tAdF7nL478jKzg2i9KiC6b2NMMoSaVM",
    },
    {
      name: "Zappier",
      color: "#ff4a00",
      link: "https://www.zappier.com/",
      img: "https://static.cdnlogo.com/logos/z/75/zapier.svg",
    },
  ],
  misc: [
    {
      name: "Linux",
      color: "#f5be04",
      link: "https://en.wikipedia.org/wiki/Unix",
      img: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/Tux.svg/1200px-Tux.svg.png",
    },
    {
      name: "Git",
      color: "#f03c2e",
      link: "https://git-scm.com/",
      img: "https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg",
    },
    {
      name: "Actions",
      color: "#2287fb",
      link: "https://github.com/features/actions",
      img: "https://avatars.githubusercontent.com/u/44036562?s=280&v=4",
    },
    {
      name: "Postman",
      color: "#ff6c37",
      link: "https://www.postman.com/",
      img: "https://iconape.com/wp-content/png_logo_vector/postman.png",
    },
    {
      name: "ES-Lint",
      color: "#4a2ec4",
      link: "https://eslint.org/",
      img: "https://eslint.org/icon-512.png",
    },
    {
      name: "Python",
      color: "#4182b3",
      link: "https://www.python.org/",
      img: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Python-logo-notext.svg/800px-Python-logo-notext.svg.png",
    },
    {
      name: "Jira",
      color: "#0f65e0",
      link: "https://www.python.org/",
      img: "https://cdn.worldvectorlogo.com/logos/jira-1.svg",
    },
  ],
};

export default SkillsList;
